import type { HTMLAttributes, ReactElement } from 'react';

import { cn } from '@/shared/lib/cn';

export function Skeleton({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>): ReactElement {
  return <div className={cn('rounded-md skeleton-shimmer', className)} {...props} />;
}
